import { render, staticRenderFns } from "./PartesTrabajo.vue?vue&type=template&id=4ab4bc86&"
import script from "./PartesTrabajo.vue?vue&type=script&lang=js&"
export * from "./PartesTrabajo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports